export default __webpack_public_path__ + "static/media/Image-1.09672b58.png";